module.exports = __webpack_public_path__ + "static/media/TrainSvg.0239dfef.svg";